let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://panin-opr.moleawiz.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://panin-opr.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://panin-opr.moleawiz.com"
} else if (environment === "staging") {
  baseUrl =
    "https://panin-opr-staging.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://panin-opr-staging.moleawiz.com"
} else {
  baseUrl =
    "https://panin-opr-staging.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://panin-opr-staging.moleawiz.com"
}

export { baseUrlOrigin };
export default baseUrl;
